import { render, staticRenderFns } from "./TelephoneEdit.vue?vue&type=template&id=c7a36274&scoped=true"
import script from "./TelephoneEdit.vue?vue&type=script&lang=js"
export * from "./TelephoneEdit.vue?vue&type=script&lang=js"
import style0 from "./TelephoneEdit.vue?vue&type=style&index=0&id=c7a36274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a36274",
  null
  
)

export default component.exports